import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

// Keys double as the `publishStatus.*` dictionary keys (values of `publish_status` from the API).
const STATUS_COLORS = {
  draft: 'default',
  saving_agent: 'processing',
  agent_saved: 'processing',
  kb_processing: 'processing',
  ready_to_publish: 'processing',
  publishing: 'processing',
  published: 'success',
  publish_failed: 'error',
  budget_exceeded: 'warning',
} as const;

type KnownStatus = keyof typeof STATUS_COLORS;

const isKnownStatus = (status: string): status is KnownStatus =>
  Object.prototype.hasOwnProperty.call(STATUS_COLORS, status);

interface AgentStatusBadgeProps {
  status: string;
}

export function AgentStatusBadge({ status }: AgentStatusBadgeProps) {
  const { t } = useTranslation('agents');

  // An unknown status is shown as-is, so a value the backend adds later stays visible.
  if (!isKnownStatus(status)) return <Tag color="default">{status}</Tag>;

  return <Tag color={STATUS_COLORS[status]}>{t(`publishStatus.${status}`)}</Tag>;
}
